
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 1.333v29.334h16.446C27.296 30.667 32 24.349 32 15.97c0-8.345-4.705-14.638-15.554-14.638H0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M1.778 3.184h14.67c9.958 0 13.775 5.654 13.775 12.787 0 8.553-5.33 12.845-13.774 12.845H1.778V3.184zM3.2 4.663v22.675h13.249c7.998 0 12.35-3.876 12.35-11.367 0-7.698-4.717-11.309-12.35-11.309H3.2z","fill":"#000"}}),_c('path',{attrs:{"d":"M4.977 17.639h4.241v7.849h-4.24v-7.85zM7.097 16.424c1.456 0 2.636-1.227 2.636-2.74 0-1.514-1.18-2.741-2.636-2.741-1.455 0-2.635 1.227-2.635 2.74 0 1.514 1.18 2.741 2.635 2.741z","fill":"#000"}}),_c('path',{attrs:{"d":"M18.113 14.966v1.271h-3.022v-5.1h2.926v1.27h-1.704v.59h1.61v1.272h-1.61v.697h1.8zm.529 1.272l1.479-5.103h1.738l1.478 5.103h-1.271l-.278-.987H20.19l-.278.987h-1.27zm1.906-2.257h.885l-.406-1.441h-.074l-.405 1.441zm3.404-2.845h1.222v3.83h1.81c-.496-6.95-5.754-8.453-10.535-8.453h-5.094v4.625h.754c1.375 0 2.228.97 2.228 2.53 0 1.61-.833 2.57-2.228 2.57h-.754v9.253h5.095c7.768 0 10.474-3.752 10.57-9.254h-3.068v-5.101zm-12.598 1.273v2.557h.755c.523 0 1.006-.157 1.006-1.299 0-1.115-.537-1.258-1.006-1.258h-.755z","fill":"#D50072"}})])
          )
        }
      }
    